import React, { useEffect, useState } from 'react';
import '../styles/video.scss';
import Loading from '../loading';
import useMobileApp from '../../../../hooks/useMobileApp';

const OverrideStylesForMobileApp = {
  height: '100vh',
  width: '100vw',
};

const VideoViewer = (props: { filePath: string; height: number }) => {
  const { filePath, height } = props;
  const [loading, setLoading] = useState(true);

  const { isMobileApp } = useMobileApp();

  useEffect(() => {
    // Fix for MOB-184
    // for context: https://stackoverflow.com/questions/25509632/audio-element-refuses-to-fire-play-event-on-android
    if (isMobileApp) setLoading(false);
  }, [isMobileApp]);

  return (
    <div className="pg-driver-view">
      <div className="video-container">
        {loading && <Loading />}
        <video
          height={height}
          className={loading ? 'video-loading' : ''}
          controls
          onCanPlay={() => setLoading(false)}
          src={filePath}
          webkit-playsinline
          playsInline
          style={isMobileApp ? OverrideStylesForMobileApp : {}}
        >
          Video playback is not supported by your browser.
        </video>
      </div>
    </div>
  );
};

export default VideoViewer;
